import { Dispatch } from "react";
import { Action } from "redux";
import { INotification } from "../../Notification/Index";
import {
  BANDINGSAVE,
  CONFIGSAVE,
  DELETE_ACTION_TYPE,
  OUTPUT_CONFIG_MAP_HIGHLIGHT,
  OUTPUT_CONFIG_MAP_HIGHLIGHT_PARENT
} from "./Constant";
import { OutputConfigSlice } from "./redux";

export const getNotificationTextBasedOnConfig = (
  notificationItems: INotification[],
  actionType: string
): string => {
  let outputConfigActionType = actionType;
  const notificationItem = notificationItems.find((notify: INotification): INotification | void => {
    if (notify.actionType === BANDINGSAVE ||
      notify.actionType === CONFIGSAVE
    )
      return notify;
    if (notify.actionType === DELETE_ACTION_TYPE) {
      outputConfigActionType = DELETE_ACTION_TYPE;
      return notify;
    }
  });
  if (notificationItem && notificationItem.actionType === outputConfigActionType)
    return notificationItem.text;
  else
    return "";
};

export const checkIfOutputConfigMessageToDisplay = (
  actionType: string
): boolean => {
  if (actionType !== CONFIGSAVE &&
    actionType !== BANDINGSAVE &&
    actionType !== DELETE_ACTION_TYPE
  ) {
    return true;
  }

  if ((actionType === CONFIGSAVE || actionType === DELETE_ACTION_TYPE) &&
    (document.querySelector(".ebt-extract__output-config-dialog-full") === null)) {
    return true;
  }
  return false;
};

export const validateIfBandingMessage = (
  notificationMessage: string,
  // eslint-disable-next-line @typescript-eslint/ban-types
  translate: Function
): boolean => {
  if (notificationMessage === translate("Notification.SaveBanding") ||
    notificationMessage === translate("Notification.DeleteBand")) {
    return true;
  }
  return false;
};

export const validateIfConfigMapMessage = (
  notificationMessage: string,
  // eslint-disable-next-line @typescript-eslint/ban-types
  translate: Function
): boolean => {
  if (notificationMessage === translate("Notification.SaveConfigMap") ||
    notificationMessage === translate("Notification.DeleteConfigMap")) {
    return true;
  }
  return false;
};

/**
 * Function that removes the mapped highlighted config
 * @param element HTML config mapping element in which the highglight has to be removed
 */
export const removeHighlight = (element: HTMLElement, className: string, dispatch: Dispatch<Action>): void => {
  const dataCheck = element.classList.contains(OUTPUT_CONFIG_MAP_HIGHLIGHT)
    || element.classList[1] === OUTPUT_CONFIG_MAP_HIGHLIGHT_PARENT;
  if (element && dataCheck) {
    setTimeout(() => {
      element.classList.remove(className);
    }, 5000);
    dispatch(OutputConfigSlice.actions.setFocusConfigId(""));
  }
};
